module.exports = __webpack_public_path__ + "static/img/38餐饮.474f03b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/38餐饮.jpg
// module id = 7sDi
// module chunks = 0